<template>
  <div class="button-container-fixed">
    <div class="form-checkbox accept-terms">
      <input
        class="checkbox"
        type="checkbox"
        id="accept-terms"
        @click="checkRegulation"
      />
      <label for="accept-terms" class="checkbox"
        ><span>{{ $t("common.agreeToTerms") }}</span></label
      >
    </div>

    <div style="width: 95%; margin: auto">
      <ItemButton
        :icon="icon"
        :label="label"
        :isDisabled="isDisabled"
        :actionType="actionType"
        @clicked="goToNextPage"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "TheMbReceiveButton",
  data() {
    return {
      // ボタンの状態の初期値
      actionType: "disabled",
      isDisabled: true,
    };
  },
  methods: {
    // チェックボックスのchecked可否によって挙動変更の処理
    checkRegulation() {
      var ele = document.getElementsByClassName("checkbox")[0];
      if (ele.checked == true) {
        this.actionType = "btn-submit";
        this.isDisabled = false;
      } else {
        this.actionType = "disabled";
        this.isDisabled = true;
      }
    },
    goToNextPage() {
      this.$emit("clicked");
    },
    backToBeforePage() {
      this.$emit("cancelClicked");
    },
  },

  props: {
    icon: String,
    label: String,
  },
};
</script>

<style lang="scss" scoped>
.button-container-fixed {
  position: fixed;
  z-index: 99;
  left: 0;
  width: 100%;
  bottom: 0;
  background-color: #ffb206;
  padding: 15px 0;
}

.button-container-fixed .accept-terms {
  margin: 0 0 15px 0;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
}

.button-container-fixed button {
  width: calc(100% - 30px);
  margin: auto;
}
</style>
